"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = exports.getErrorMessageStyles = exports.ErrorIcon = exports.ERROR_MESSAGE_TYPE = void 0;
var react_1 = require("@emotion/react");
var react_2 = __importDefault(require("react"));
var icons_1 = require("../../../icons");
var styles_1 = require("../../../styles");
exports.ERROR_MESSAGE_TYPE = {
    global: 'global',
    field: 'field',
    submission: 'submission',
};
var isField = function (type) {
    return type === exports.ERROR_MESSAGE_TYPE.field;
};
var getIconStyles = function (type) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: translateY(2px);\n  margin-right: ", ";\n  > svg {\n    fill: ", ";\n    width: 1.1em;\n    height: 1.1em;\n  }\n"], ["\n  transform: translateY(2px);\n  margin-right: ", ";\n  > svg {\n    fill: ", ";\n    width: 1.1em;\n    height: 1.1em;\n  }\n"])), isField(type) ? '2px' : '4px', styles_1.COLOR.font.error); };
var ERROR_ICON_CLASS_NAME = 'errorIcon';
var ErrorIcon = function () { return (react_2.default.createElement("div", { className: ERROR_ICON_CLASS_NAME, dangerouslySetInnerHTML: {
        __html: icons_1.ERROR_ICON,
    } })); };
exports.ErrorIcon = ErrorIcon;
var ERROR_MESSAGE_CLASS_NAME = 'errorMessage';
var getErrorMessageStyles = function (type) { return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .", " {\n    color: ", ";\n    font-size: ", ";\n    line-height: 1.7;\n    display: flex;\n    justify-content: ", ";\n    word-break: break-all;\n\n    & > .", " {\n      ", "\n    }\n  }\n"], ["\n  .", " {\n    color: ", ";\n    font-size: ", ";\n    line-height: 1.7;\n    display: flex;\n    justify-content: ", ";\n    word-break: break-all;\n\n    & > .", " {\n      ", "\n    }\n  }\n"])), ERROR_MESSAGE_CLASS_NAME, styles_1.COLOR.font.error, isField(type) ? '12px' : '14px', type === exports.ERROR_MESSAGE_TYPE.submission
    ? 'center'
    : 'flex-start', ERROR_ICON_CLASS_NAME, getIconStyles(type)); };
exports.getErrorMessageStyles = getErrorMessageStyles;
var ErrorMessage = function (_a) {
    var errorMessage = _a.errorMessage;
    return (react_2.default.createElement("div", { className: ERROR_MESSAGE_CLASS_NAME, "data-cy-error": true },
        react_2.default.createElement(exports.ErrorIcon, null),
        react_2.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: errorMessage,
            } })));
};
exports.ErrorMessage = ErrorMessage;
var templateObject_1, templateObject_2;
